import { render } from "./UpdateProfileInformationForm.vue?vue&type=template&id=ce55a224"
import script from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "ce55a224"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce55a224', script)) {
    api.reload('ce55a224', script)
  }
  
  module.hot.accept("./UpdateProfileInformationForm.vue?vue&type=template&id=ce55a224", () => {
    api.rerender('ce55a224', render)
  })

}

script.__file = "resources/js/Pages/Profile/Partials/UpdateProfileInformationForm.vue"

export default script